export interface IPricesHubShort {
    videoId: string;
    title: string;
}

export const PRICES_HUB_SHORTS_CHANNEL_NAME = "Misja Mieszkanie";
export const PRICES_HUB_SHORTS_CHANNEL_HREF = "https://www.youtube.com/@MisjaMieszkanie";

export const PRICES_HUB_SHORTS: IPricesHubShort[] = [
    {videoId: "HpTP-6TV_5o", title: "Czy młodych Polaków stać dziś na mieszkanie? Sonda uliczna"},
    {videoId: "i0N_kMSw_aA", title: "Dlaczego Polacy chcą mieć mieszkanie na własność?"},
    {videoId: "K73lSKCVhIY", title: "Ceny apartamentowców w Warszawie i Grodzisku Mazowieckim"},
    {videoId: "8bVOoyabBDw", title: "Dlaczego metr kwadratowy mieszkania jest aż tak drogi?"},
    {videoId: "sobx9mNetvQ", title: "Kto ma dostęp do mieszkań ze spółdzielni. Czy da się je kupić taniej?"},
    {videoId: "bihcz0deunY", title: "Jaki kredyt hipoteczny wybrać? Odpowiada Andrzej Fluderski z Gethome Finance"},
    {videoId: "lVnU9twoqzw", title: "Gdzie znaleźć tańsze mieszkania"}
];
export interface IPricesHubShort {
    videoId: string;
    title: string;
}

export const PRICES_HUB_SHORTS_CHANNEL_NAME = "Misja Mieszkanie";
export const PRICES_HUB_SHORTS_CHANNEL_HREF = "https://www.youtube.com/@MisjaMieszkanie";

export const PRICES_HUB_SHORTS: IPricesHubShort[] = [
    {videoId: "HpTP-6TV_5o", title: "Czy młodych Polaków stać dziś na mieszkanie? Sonda uliczna"},
    {videoId: "i0N_kMSw_aA", title: "Dlaczego Polacy chcą mieć mieszkanie na własność?"},
    {videoId: "K73lSKCVhIY", title: "Ceny apartamentowców w Warszawie i Grodzisku Mazowieckim"},
    {videoId: "8bVOoyabBDw", title: "Dlaczego metr kwadratowy mieszkania jest aż tak drogi?"},
    {videoId: "sobx9mNetvQ", title: "Kto ma dostęp do mieszkań ze spółdzielni. Czy da się je kupić taniej?"},
    {videoId: "bihcz0deunY", title: "Jaki kredyt hipoteczny wybrać? Odpowiada Andrzej Fluderski z Gethome Finance"},
    {videoId: "lVnU9twoqzw", title: "Gdzie znaleźć tańsze mieszkania"}
];
